import styled, { css } from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing, fontWeight } from 'stylesheetB2b';

import { AudioOptionButtonState } from './AudioOptionButton.const';

const BUTTON_SIZE = getSpacing(10);
const INACTIVE_BUTTON_OPACITY = 0.5;

const disabledButtonStyle = (colors: ColormapInterface) => css`
  background-color: ${colors.buttonDisabled};
  color: ${colors.buttonIconDisabled};
  pointer-events: none;
  cursor: default;
`;
const defaultButtonStyle = (colors: ColormapInterface) => css`
  background-color: ${colors.buttonSecondary};
  color: ${colors.buttonAudioOptionDefault};
  pointer-events: auto;
  cursor: pointer;
`;

const activeBorderStyle = (colors: ColormapInterface) => css`
  border: 3px solid ${colors.audioOptionButton.activeBorder};
  box-shadow: 0 0 20px ${colors.audioOptionButton.activeBorderGlow};
`;
const defaultBorderStyle = css`
  border: none;
  box-shadow: none;
`;

interface ButtonProps {
  buttonState: AudioOptionButtonState;
  colors: ColormapInterface;
}

export const StyledButton = styled.button<ButtonProps>`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ buttonState, colors }) => css`
    ${buttonState === AudioOptionButtonState.DISABLED
      ? disabledButtonStyle(colors)
      : defaultButtonStyle(colors)
    }
    ${buttonState === AudioOptionButtonState.ACTIVE ? activeBorderStyle(colors) : defaultBorderStyle
    }
  `}
  border-radius: 50%;
  width: ${BUTTON_SIZE};
  height: ${BUTTON_SIZE};
  margin-bottom: ${getSpacing(1)};
`;
StyledButton.displayName = 'StyledButton';

interface ContainerProps {
  buttonState: AudioOptionButtonState;
  colors: ColormapInterface;
}

export const StyledAudioOption = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: ${fontWeight.bold};
  ${({ buttonState, colors }) =>
    buttonState === AudioOptionButtonState.DISABLED &&
    css`
      color: ${colors.buttonDisabled};
      opacity: ${INACTIVE_BUTTON_OPACITY};
    `}
  margin: ${getSpacing(2)};
  font-size: ${getSpacing(2)};
`;
StyledAudioOption.displayName = 'StyledAudioOption';
